import axios from "axios";
import generalInterceptor from "./interceptor";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_PREFIX || "",
  timeout: 5000,
});

generalInterceptor(instance);

export default instance;
